import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { TopNav } from "./TopNav";
import { SideNav } from "./SideNav";
import { LayoutBox, LayoutContainer, LayoutRoot, LayoutWithNavBarStyles } from "./Layout.styles";
import { keyValueStorage } from "../../common/logic/KeyValueStore";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../hooks/StoreHooks";
import { setfirstOpenCheck } from "../../store/reducers/firstOpenCheckReducer";
import { useFirstOpenCheck } from "../../store/selectors/firstOpenCheckSelector";
import { fetchActionModules } from "../../store/thunk/actionsModulesThunk";
import { setFeatureFlagList, setSupportedLanguages } from "../../store/reducers/loginMetadataReducer";
import { setCurrentUserPermissionList } from "../../store/reducers/permissionsReducer";
import { authenticationStateHandler } from "../../authentication/logic/AuthenticationStateHandler";
import { useObservable } from "../../common/ui/ObservableHook";
import PortalShutdownNoticeDialog from "../../components/common/PortalShutdownNoticeDialog";
import {
  confirmPortalShutdownNotice,
  hasConfirmedPortalShutdownNotice,
} from "../../components/common/portalShutdownNoticeStorage";

export function LayoutsWithNavbar() {
  const [navOpen, setNavOpen] = useState(false);
  const [firstOpenModal, setFirstOpenModal] = useState(false)
  const profile = useObservable(authenticationStateHandler.profileObservable, authenticationStateHandler.profile);
  const [shutdownNoticeOpen, setShutdownNoticeOpen] = useState(false);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isFirstOpenTodayStoreValue = useFirstOpenCheck()
  const [, setResponseMessage] = useState<string | undefined>(undefined);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const featureFlags = keyValueStorage.getObject<string[]>("featureFlags", []);
    if (featureFlags.includes("TestCompany") && isFirstOpenTodayStoreValue) {
      setFirstOpenModal(true)
    }
  }, [isFirstOpenTodayStoreValue]);

  useEffect(() => {
    setShutdownNoticeOpen(profile != null && !hasConfirmedPortalShutdownNotice(profile.id));
  }, [profile]);

  useEffect(() => {
    dispatch(fetchActionModules());
  }, [dispatch]);

  useEffect(() => {
    if (firstOpenModal) {
      setResponseMessage(t("dialogModals.firstOpenToday"));
    }
  }, [firstOpenModal]);

  useEffect(() => {
    const storedFlags = keyValueStorage.getObject<string[]>("featureFlags", []);
    if (storedFlags.length > 0) {
      dispatch(setFeatureFlagList(storedFlags));
    }
    const storedLanguages = keyValueStorage.getObject<string[]>("supportedLanguages", []);
    if (storedLanguages.length > 0) {
      dispatch(setSupportedLanguages(storedLanguages));
    }
    const permissions = keyValueStorage.getObject<string[]>("assignedPermissions", []);
    if (permissions.length > 0) {
      dispatch(setCurrentUserPermissionList(permissions));
    }

    const lastOpenDate = keyValueStorage.getObject('lastOpenDate', "");
    const currentDate = new Date();
    const lastOpenDateFormatted = new Date(lastOpenDate.replace(/^"|"$/g, ''));
    const isDifferentDay =
      !lastOpenDate ||
      lastOpenDateFormatted.getFullYear() !== currentDate.getFullYear() ||
      lastOpenDateFormatted.getMonth() !== currentDate.getMonth() ||
      lastOpenDateFormatted.getDate() !== currentDate.getDate();
    if (isDifferentDay) {
      dispatch(setfirstOpenCheck(true));
    }
    keyValueStorage.setObject("lastOpenDate", currentDate.toISOString());
  }, [dispatch]);

  return (
    <LayoutWithNavBarStyles>
      <TopNav onNavOpen={() => setNavOpen(true)} collapsed={collapsed} />
      <SideNav
        onClose={() => setNavOpen(false)}
        open={navOpen}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
      />
      <LayoutRoot collapsed={collapsed}>
        <LayoutContainer>
          <LayoutBox>
            <Outlet />
          </LayoutBox>
        </LayoutContainer>
      </LayoutRoot>
      <PortalShutdownNoticeDialog
        open={shutdownNoticeOpen}
        onClose={() => setShutdownNoticeOpen(false)}
        onConfirm={() => {
          if (profile != null) {
            confirmPortalShutdownNotice(profile.id);
          }
          setShutdownNoticeOpen(false);
        }}
      />
    </LayoutWithNavBarStyles>
  );
}


